import { render, staticRenderFns } from "./DashboardContentComponent.vue?vue&type=template&id=16948056&scoped=true"
import script from "./DashboardContentComponent.vue?vue&type=script&lang=js"
export * from "./DashboardContentComponent.vue?vue&type=script&lang=js"
import style0 from "./DashboardContentComponent.vue?vue&type=style&index=0&id=16948056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16948056",
  null
  
)

export default component.exports